'use strict';

module.exports = strikethrough;

var all = require('../all');

function strikethrough(h, node) {
  return h(node, 'delete', all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/delete.js
// module id = 1025
// module chunks = 0